<template>
  <section id="nextPage">
    <span id="currentStep">Schritt {{currentStep}} von {{numberOfActiveSteps}}</span>
    <template v-if="check === null || check === true">
      <router-link :to="next" v-ripple.mouseover="'rgba(255, 255, 255, 0.1)'" class="button button-next" :aria-label="nextText">{{nextText}}</router-link>
    </template>
    <template v-else>
      <span @click="$emit('falseClick')" v-ripple.mouseover="'rgba(255, 255, 255, 0.1)'" class="button button-next button-disabled" aria-label="nächster Schritt nicht möglich">{{nextText}}</span>
    </template>
  </section>
</template>
<script>
export default {
  name: 'Controller',
  props: {
    check: {
      type: Boolean,
      default: null
    },
    nextText: {
      type: String,
      default: 'Nächster Schritt'
    },
    prevText: {
      type: String,
      default: ''
    },
    next: {
      type: String,
      default: '/'
    },
    prev: {
      type: String,
      default: ''
    }
  },
  computed: {
    activeValues: function () {
      return this.activeSteps.filter(step => step.active)
    },
    numberOfActiveSteps: function () {
      return this.activeValues.length
    },
    currentStep: function () {
      return this.activeValues.indexOf(this.activeValues.find(item => item.id === this.$route.name)) + 1
    },
    activeSteps: function () {
      return [
        {
          id: 'Templates',
          active: true
        },
        {
          id: 'Sprachen',
          active: true
        },
        {
          id: 'Plug-ins',
          active: true
        },
        {
          id: 'Blog',
          active: this.$root.items.find(item => item.id === 'blogfunktion').status
        },
        {
          id: 'Online Shop',
          active: this.$root.items.find(item => item.id === 'onlineshop').status
        },
        {
          id: 'Technisches',
          active: true
        },
        {
          id: 'Services',
          active: true
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/css/variables.scss";
#nextPage {
  user-select: none;
  background: #ddd;
  padding: 42px 0 40px 0;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
  #currentStep {
    display: none;
    align-items: center;
    margin-left: 15px;
    width: 60px;
    text-align: center;
    font-family: $primaryFont;
  }
  .button {
    margin-right: 15px;
  }
  .button-next,
  .button-next:hover,
  .button-next:focus,
  .button-next:visited,
  .button-next:active {
    background:#5373FF;
    color:#fff;
    text-decoration:none;
    -webkit-appearance: none;
    position: relative;
    overflow: hidden;
    font-family: $secondaryFont;
    font-weight: $secondaryFontBold;
    padding:12px 29px 12px 30px;
    outline: none;
    line-height: 1;
    border-radius: 25px;
    font-size: 18px;
    transform: translate3d(0,0,0); // ripple bug
    align-self: end;
    align-self: flex-end;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    &:after {
      content:'';
      display:inline-block;
      background-position:center center;
      background-repeat:no-repeat;
      margin-left:6px;
      position: relative;
      top: 2px;
      background-image:url('../assets/img/icons/buttons/nextwhite.svg');
      width: 18px;
      height: 15px;
    }
    &::-moz-focus-inner {
      border: 0;
      padding: 0;
    }
  }
  .button-disabled {
    filter: grayscale(1);
    &:hover {
      cursor: not-allowed;
    }
  }
}
@media (min-width:767px) {
  #nextPage {
    #currentStep {
      margin-left: 142px;
      width: auto;
      text-align: left;
    }
    .button {
      margin-right: 40px;
    }
    .button-next,
    .button-next:hover,
    .button-next:focus,
    .button-next:visited,
    .button-next:active {
      font-size: 19px;
      &:after {
        width: 19px;
      }
    }
  }
}
@media (min-height:420px) {
  #nextPage {
    justify-content: space-between;
    #currentStep {
      display: flex;
    }
    background-color: #fff;
    background-color: rgba(255, 255, 255, 1);
    width: 100%;
    padding: 32px 0 30px 0;
    margin: 0;
    z-index: 3;
    position: fixed;
    bottom: 0;
    right: 0;
    border-top: 2px solid $primaryColor;
  }
  @supports ((-webkit-backdrop-filter: blur(8px)) or (backdrop-filter: blur(8px))) {
    #nextPage {
      background-color: rgba(255, 255, 255, 0.92);
      -webkit-backdrop-filter: blur(8px);
      backdrop-filter: blur(8px);
    }
  }
}
@media (min-height:520px) {
  #nextPage {
    padding: 42px 0 40px 0;
  }
}

@media (min-width:1200px) {
  .closed-large-overview {
    #nextPage {
      #currentStep {
        margin-left: 142px;
      }
    }
  }
  #nextPage {
    #currentStep {
      margin-left: 320px;
    }
  }
}
</style>
